document.addEventListener('DOMContentLoaded', function () {
  const els = document.querySelectorAll('.js-image-reveal');
  const io = new IntersectionObserver(
    e =>
      e.forEach(t => {
        if (t.isIntersecting) {
          t.target.classList.add('in-view');
          io.unobserve(t.target);
        }
      }),
    { threshold: 0.3 }
  );
  els.forEach(el => io.observe(el));
});
